export default {
  LOGIN_MODAL_TOGGLE: "LOGIN_MODAL_TOGGLE",
  EDIT_PROFILE_MODAL_TOGGLE: "EDIT_PROFILE_MODAL_TOGGLE",
  EXPORT_MODAL_TOGGLE: "EXPORT_MODAL_TOGGLE",
  THANK_YOU_MODAL_TOGGLE: "THANK_YOU_MODAL_TOGGLE",
  EDIT_GIVE_URL_MODAL_TOGGLE: "EDIT_GIVE_URL_MODAL_TOGGLE",
  COLUMN_MODAL_TOGGLE: "COLUMN_MODAL_TOGGLE",
  COLUMN_MODAL_CHANGE: "COLUMN_MODAL_CHANGE",
  USER_PROFILE_MODAL_TOGGLE: "USER_PROFILE_MODAL_TOGGLE",
  CHANGE_PASSWORD_MODAL_TOGGLE: "CHANGE_PASSWORD_MODAL_TOGGLE",
  CREATE_REQUEST_MODAL_TOGGLE: "CREATE_REQUEST_MODAL_TOGGLE",
  REQUEST_DETAIL_MODAL_TOGGLE: "REQUEST_DETAIL_MODAL_TOGGLE",
  MEDIA_MODAL_TOGGLE: "MEDIA_MODAL_TOGGLE",
  MEDIA_MODAL_BLOBS_CLEAR: "MEDIA_MODAL_BLOBS_CLEAR",
  // Custom Thumbnail Modal
  CUSTOM_THUMBNAIL_MODAL_TOGGLE: "CUSTOM_THUMBNAIL_MODAL_TOGGLE",
  RESET_CUSTOM_THUMBNAIL_MODAL: "RESET_CUSTOM_THUMBNAIL_MODAL",

  DONOR_FLAG_MODAL_TOGGLE: "DONOR_FLAG_MODAL_TOGGLE",
  SEGMENT_MANAGER_MODAL_TOGGLE: "SEGMENT_MANAGER_MODAL_TOGGLE",
  POST_NOTIFICATION_MODAL_TOGGLE: "POST_NOTIFICATION_MODAL_TOGGLE",

  LOGIN_USER: "LOGIN_USER",
  CHANGE_CURRENT_CHARITY: "CHANGE_CURRENT_CHARITY",
  LOGOUT_USER: "LOGOUT_USER",
  UPDATE_PHOTO_URL: "UPDATE_PHOTO_URL",
  UPDATE_PROFILE: "UPDATE_PROFILE",
  UPDATE_CHARITIES: "UPDATE_CHARITIES",
  REMEMBER_USER: "REMEMBER_USER",

  CHANGE_SELECTED_ITEMS: "CHANGE_SELECTED_ITEMS",
  HIDE_SELECTED_ITEMS: "HIDE_SELECTED_ITEMS",
  REFRESH_DASHBOARD: "REFRESH_DASHBOARD",
  TOGGLE_VIEWSPARK_BUTTON: "TOGGLE_VIEWSPARK_BUTTON",

  MESSENGER_OPTION: "MESSENGER_OPTION",
};
